import { useState } from 'react'
import { Button, Checkbox, Modal, Space } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

import { SelectionInfoContainer } from '../../../../atom/box'
import { V3Transaction } from '../../../../models/v3-transaction'

interface BulkSettleBarProps {
  transactions: V3Transaction[]
  selectedRowKeys: number[]
  bulkSettleLoading: boolean
  onSelectAllOnPage: (selected: boolean) => void
  onBulkSettle: () => void
}

const BulkSettleBar: React.FC<BulkSettleBarProps> = ({
  transactions,
  selectedRowKeys,
  bulkSettleLoading,
  onSelectAllOnPage,
  onBulkSettle,
}) => {
  const [confirmVisible, setConfirmVisible] = useState(false)

  const currentPageIds = transactions.map((t) => t.id)
  const selectedOnPage = currentPageIds.filter((id) => selectedRowKeys.includes(id)).length
  const allOnPageSelected = currentPageIds.length > 0 && selectedOnPage === currentPageIds.length
  const indeterminate = selectedOnPage > 0 && selectedOnPage < currentPageIds.length

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    onSelectAllOnPage(e.target.checked)
  }

  const selectedCount = selectedRowKeys.length

  const handleConfirm = () => {
    setConfirmVisible(false)
    onBulkSettle()
  }

  return (
    <>
      <SelectionInfoContainer align="middle" justify="space-between">
        <Space>
          <Checkbox
            indeterminate={indeterminate}
            checked={allOnPageSelected}
            onChange={handleCheckboxChange}
          />
          <span className="paragraph-01-regular">
            {selectedCount > 0
              ? `${selectedCount} invoice${selectedCount !== 1 ? 's' : ''} awaiting settlement`
              : `${currentPageIds.length} invoice${currentPageIds.length !== 1 ? 's' : ''} awaiting settlement`}
          </span>
        </Space>
        <Button
          type="primary"
          loading={bulkSettleLoading}
          disabled={selectedCount === 0}
          onClick={() => setConfirmVisible(true)}
        >
          Mark as Settled
        </Button>
      </SelectionInfoContainer>

      <Modal
        title="Confirm Settlement"
        visible={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        footer={
          <Space>
            <Button onClick={() => setConfirmVisible(false)}>
              Cancel
            </Button>
            <Button type="primary" loading={bulkSettleLoading} onClick={handleConfirm}>
              Mark as Settled
            </Button>
          </Space>
        }
      >
        <p>
          You are about to mark <strong>{selectedCount} transaction{selectedCount !== 1 ? 's' : ''}</strong> as settled.
        </p>
        <p>This will update their payment state from <strong>Invoiced</strong> to <strong>Settled</strong>. This action cannot be undone.</p>
      </Modal>
    </>
  )
}

export default BulkSettleBar
